import styled from 'styled-components';

import {colorVar} from '../../Theme/colors';
import AbsLayer from './AbsLayer';

const FilledDisabledBaseLayer = styled(AbsLayer)`
  background-color: ${colorVar('onSurface')};
  opacity: 0.12;
`;

export default FilledDisabledBaseLayer;
